document.addEventListener("DOMContentLoaded", () => {
  const TOKEN_KEY = "accessToken";

  const token = localStorage.getItem(TOKEN_KEY);

  // 1) No token → 즉시 할인 상태 정리 후 종료
  if (!token) {
    sessionStorage.removeItem('discount_type');
    updateAllPrices('normal');
    removeCartAttribute();
    return;
  }

  // 2) 토큰 있을 때만 sessionStorage 기반 즉시 가격 업데이트
  const savedType = sessionStorage.getItem('discount_type');
  if (savedType) {
    updateAllPrices(savedType);
  }

  // 3) If token exists → fetch session API
  if (token) {
    fetch(FILA_API_BASE_URL + "/api/v1/auth/session-type", {
      headers: { "Authorization": `Bearer ${token}` }
    })
    .then(r => r.json())
    .then(data => {
      let type = 'normal';

      if (data.session_type === "employee") {
        type = "emp_sl_uprc";
      }
      else if (data.session_type === "friends" && data.dcrt_base_cd === "DCRT_BASE1") {
        type = "frds_sl_uprc1";
      }
      else if (data.session_type === "friends" && data.dcrt_base_cd === "DCRT_BASE2") {
        type = "frds_sl_uprc2";
      }
      else if (data.session_type === "friends" && data.dcrt_base_cd === "DCRT_BASE3") {
        type = "frds_sl_uprc3";
      }
      else if (data.session_type === "donation") {
        type = "donation";
      }
      else if (data.session_type === "normal") {
        type = "normal";
      }
      else {
        removeCartAttribute();
        return;
      }

      // 세션 API 응답 직후 즉시 가격 업데이트 (Cart 업데이트 기다리지 않음)
      const previousType = sessionStorage.getItem('discount_type');
      if (previousType !== type) {
        sessionStorage.setItem('discount_type', type);
        updateAllPrices(type);
      }

      // Cart 업데이트는 백그라운드로 실행
      applyCartAttribute(type);
    })
    .catch(() => {
      console.warn('Error fetching session data');
      // 세션 API 실패 시 할인 상태 전체 정리 (만료된 토큰 등)
      sessionStorage.removeItem('discount_type');
      updateAllPrices('normal');
      removeCartAttribute();
    });
  }

  // -------------------------------
  // Apply Cart Attribute (백그라운드)
  // -------------------------------
  function applyCartAttribute(type) {
    const accessToken = localStorage.getItem(TOKEN_KEY);
    if (!accessToken || !window.routes || !window.routes.cart_update_url) {
      return;
    }

    const body = JSON.stringify({
      attributes: {
        discount_metafield: type
      }
    });

    fetch(window.routes.cart_update_url, { 
      ...fetchConfig(), 
      ...{ body } 
    })
    .then(response => response.json())
    .catch(error => {
      console.error('Error applying cart attribute:', error);
    });
  }

  function removeCartAttribute() {
    // sessionStorage 즉시 정리 (동기 — fetch 완료를 기다리지 않음)
    sessionStorage.removeItem('discount_type');

    if (!window.routes || !window.routes.cart_update_url) {
      return;
    }

    const body = JSON.stringify({
      attributes: {
        discount_metafield: ''
      }
    });

    // cart attribute 비동기 정리 (다음 페이지 로드 시 Liquid 정상 렌더)
    fetch(window.routes.cart_update_url, {
      ...fetchConfig(),
      ...{ body }
    })
    .then(response => response.json())
    .catch(error => {
      console.error('Error removing cart attribute:', error);
    });
  }

  // -------------------------------
  // 가격 즉시 업데이트 (DOM 기반)
  // -------------------------------
  function updateAllPrices(type) {
    const typeKey = getTypeKey(type);
    const priceElements = document.querySelectorAll('.price-display');

    priceElements.forEach(el => {
      if (el.dataset.manualPriceMode === 'text') return;

      const currentPrice = el.getAttribute(`data-price-${typeKey}`);
      const comparePrice = el.getAttribute(`data-compare-${typeKey}`);
      const discount = el.getAttribute(`data-discount-${typeKey}`);
      const isSale = el.getAttribute(`data-sale-${typeKey}`) === 'true';

      if (!currentPrice) return;

      // 현재가 업데이트
      const currentPriceEl = el.querySelector('.price-display__current-price');
      if (currentPriceEl) {
        currentPriceEl.textContent = formatMoney(currentPrice);
      }

      // 정가 업데이트
      const originalPriceEl = el.querySelector('.price-display__original-price');
      const originalContainer = el.querySelector('.price-display__original');
      if (originalPriceEl && originalContainer) {
        if (isSale && comparePrice && parseInt(comparePrice) > 0) {
          originalPriceEl.textContent = formatMoney(comparePrice);
          originalContainer.style.display = '';
        } else {
          originalContainer.style.display = 'none';
        }
      }

      // 할인율 업데이트
      const discountEl = el.querySelector('.price-display__discount-percentage');
      const discountContainer = el.querySelector('.price-display__discount');
      if (discountEl && discountContainer) {
        if (isSale && discount && parseInt(discount) > 0) {
          discountEl.textContent = discount + '%';
          discountContainer.style.display = '';
        } else {
          discountContainer.style.display = 'none';
        }
      }

      // data-on-sale 속성 업데이트
      if (isSale) {
        el.setAttribute('data-on-sale', 'true');
      } else {
        el.removeAttribute('data-on-sale');
      }
    });
  }

  // 타입을 data 속성 키로 변환
  function getTypeKey(type) {
    const typeMap = {
      'emp_sl_uprc': 'emp',
      'frds_sl_uprc1': 'frds1',
      'frds_sl_uprc2': 'frds2',
      'frds_sl_uprc3': 'frds3',
      'donation': 'donation',
      'normal': 'normal',
      '': 'normal'
    };
    return typeMap[type] || 'normal';
  }

  // 가격 포맷팅 (원화)
  function formatMoney(cents) {
    if (!cents) return '';
    const amount = parseInt(cents) / 100;
    return amount.toLocaleString('ko-KR') + '원';
  }
});
